export default {
  联系我们: '联系我们',
  播放视频: '播放视频',
  智能一键采购: '智能一键采购',
  找不到匹配的产品一键帮您采购下单: '找不到匹配的产品？一键帮您采购下单',
  产品规格: '产品规格',
  规格: '规格',
  价格面议: '价格面议',
  元: '元',
  起售: '起售',
  总数: '总数',
  已选清单: '已选清单',
  服务与承诺: '服务与承诺',
  品牌: '品牌',
  '3D产品': '3D产品',
  意向采购下单: '意向采购下单',
  你可能还喜欢: '你可能还喜欢',
  分析匹配的展品说明: '根据云展动力平台大数据分析,智能匹配以下企业展品',
  '企业云展系统（产品详情页）': '企业云展系统',
  采购单确认: '采购单确认',
  供货: '供货',
  货品金额总计: '货品金额总计（不包含运费）',
  采购意向已提交成功: '您的采购意向已提交成功, 供货商会在1-3个工作日与您联系',
  查看我的采购单: '查看我的采购单',
  提交成功: '提交成功!',
  该产品已下架: '该产品已下架',
  该产品不存在: '该产品不存在',
  序号: '序号',
  数量: '数量',
  单位: '单位',
  单价: '单价',
  小计: '小计',
  请选择所需产品数量: '请选择所需产品数量',
  选择采购产品的分类: '选择采购产品的分类',
  找不到心仪的产品快来一键帮您采购下单: '找不到心仪的产品？快来一键帮您采购下单',
  进行查看: '进行查看',
  去发布招标: '去发布招标',
  未匹配到符合的企业展品提示1: '很遗憾,经过系统大数据分析,暂未匹配到符合的企业展品',
  未匹配到符合的企业展品提示2: '您也可以直接发布招标服务,可以让有该资源的企业主动联系您！',
  暂无匹配: '暂无匹配',
  会员中心我的采购: '会员中心-我的采购',
  推荐匹配的展品说明1: '根据您所选择的感兴趣企业展品分类,系统利用大数据分析,已为您自动生成了',
  推荐匹配的展品说明2: '个意向采购单, 您可以在',
  一级行业二级行业: '一级行业/二级行业',
  系统正在努力匹配中: '系统正在努力匹配中....',
  下单成功: '下单成功',
  '3D': '3D',
  产品视频: '产品视频',
}
